<template>

    <div class="main">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>
        <!-- 標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>    

        <div style="display: flex; justify-content: space-between;">
            <div>
                <!-- 燈號狀態 -->
                <div class="status-light-info" v-show="isPermissions">
                    <span data-v-45e032f4="" class="status-light on"></span> 正常
                    <span data-v-45e032f4="" class="status-light error"></span> 超過3小時沒感測資料
                    <span data-v-45e032f4="" class="status-light off"></span> 完全沒有感測資料
                </div>
            </div>
            <div>
                <!-- 總筆數 -->
                <div class="page-row-info" v-show="isPermissions">
                    共有 {{ table.rowCount }} 筆結果。
                </div>
            </div>
        </div>

        <!-- 表格 -->
        <div class="table-scroll" v-show="isPermissions">
            <table>
                <thead>
                    <tr>
                        <th nowrap="nowrap" class="table-field" >感測站名稱</th>
                        <th nowrap="nowrap" class="table-field" >位置</th>
                        <th nowrap="nowrap" class="table-field" >經緯度</th>
                        <th nowrap="nowrap" class="table-field" style="width: 125px;">最後更新感測時間</th>
                        <th nowrap="nowrap" class="table-field" >燈號狀態</th>
                    </tr>
                </thead>
                <tbody v-show="table.menu.length > 0 ">
                    <template v-for="(value, key) in table.menu">
                        <tr :key="'item'+key">
                            <!-- 感測站名稱 -->
                            <td nowrap="nowrap" class="table-value">{{ value.Name }}</td>
                            <!-- 位置 -->
                            <td nowrap="nowrap" class="table-value">{{ getLocation(value) }}</td>
                            <!-- 經緯度 -->
                            <td nowrap="nowrap" class="table-value">{{ getLatLng(value) }}</td>
                            <!-- 最後更新感測時間 -->
                            <td nowrap="nowrap" class="table-value">{{ getCreateTime(value) }}</td>
                            <!-- 燈號狀態 -->
                            <td nowrap="nowrap" class="table-value">
                                <span
                                    class="status-light" :class="getStatusLight(value)">
                                </span>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <!-- 其他 -->
        <div class="no-permissions" v-show="!isPermissions">
            您目前沒有權限瀏覽此頁面，請使用管理者權限的帳號登入。
        </div>

    </div>
    
</template>
<script>

    export default {
        data() {
            return {

                website_prefix:'http://localhost:59489/',

                apiWeatherStationYunlinAdminSelect: (data) => this.userRequest.get("/API/Default/WeatherStationYunlinAdmin", data),

                //標題
                title:"雲林微氣候觀測站",
                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '雲林微氣候觀測站',
                        active: true
                    }
                ],

                //是否是在開發模式
                isDevelop:false,

                //是否有權限操作
                isPermissions:false,

                //表格
                table:{

                    //表單
                    menu:[],
                    //總頁數
                    pageCount:0,
                    //總筆數
                    rowCount:0,
                    //清單排序
                    orderBy:"ID Desc ",
                    // 分頁所在
                    pageAt:1,
                    // 分頁筆數
                    pageSize:10,
                },

            }
        },
        watch: {

        },
        mounted(){

            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);
                   
            //window.vue.isPermissions = false;
            //測試專用
            window.vue.isPermissions = true;

            this.apiGetAccountInfo({

                TokenID:sessionStorage.getItem("TokenID")
            })
            .then((res) => {

                var data = JSON.parse(res.data);
                if(data.EXIST && data.AG_ID == "0"){

                    window.vue.isPermissions = true;
                    //取得種植登記紀錄
                    //this.onSelect();
                }

                this.onSelect();
            })
            .catch((error) => {
                alert("發生錯誤!" + error);
            });
        },
        created() {
               
        },
        destroyed() {

        },
        methods: {

            //啟用遮罩
            enableDefaultLoad:function()
            {
                this.enableMask();
                this.default_load = true;
            },
            //取消遮罩
            disableDefaultLoad:function()
            { 
                //暫時先設定延遲，否則watch會重複觸發
                const _this = this;
                window.ThreadTool.Delay(function(){
                
                    _this.disableMask();
                    _this.default_load = false;

                },this.delay_ms_api);
            },   

            // 查詢
            onSelect:function(){

                this.apiWeatherStationYunlinAdminSelect({

                })
                .then((res) => {

                    var data = JSON.parse(res.data);
                    
                    this.table.menu = data;
                    console.log(this.table.menu);
                    this.table.rowCount = data.length;
                })
                .catch((error) => {
                    alert("發生錯誤!" + error);
                });
            },

            //取得位置
            getLocation:function(val)
            {
                var temp = "";

                if(val.Town == null)
                {
                    temp += "沒有位置資訊";
                }
                else
                {
                    temp += val.Town;

                    if(val.SitesecName != null && val.SitesecName != "")
                    {
                        temp += "-" + val.SitesecName.replace(val.Town, " "); 

                        if(val.SitesecNumber != null && val.SitesecNumber != "")
                        {
                            temp += "-" + val.SitesecNumber; 
                        }
                    }

                    if(val.SitesecName != null && val.SitesecName != "")
                    {
                        temp += "(" + val.Code + ")"; 
                    }
                }
                
                return temp;
            },

            //取得經緯度
            getLatLng:function(val)
            {
                var temp = "";
                if(val.LatSitesec == null || val.LatSitesec == "" || val.LngSitesec == null || val.LngSitesec == "")
                {
                    temp += "沒有經緯度資料";
                
                }else{

                    temp += val.LatSitesec + " , " + val.LngSitesec; 
                }
                
                return temp;
            },

            //取得感測時間
            getCreateTime:function(val){

                var temp = "";
                if(val.CreateTime == null || val.CreateTime == "")
                {
                    temp += "沒有感測資料";
                }
                else
                {
                    temp += val.CreateTime.replace("T", " ");
                }
                return temp;
            },

            getStatusLight:function(val){ 
                var temp = "";
                if(val.CreateTime == null || val.CreateTime == "")
                {
                    temp = "off";
                }else{
                    if(this.isOver3Hours(val.CreateTime))
                    {
                        temp = "error";
                    }
                    else
                    {
                        temp = "on";
                    }
                }
                return temp;
            },

            isOver3Hours:function(timeStr) {
                const inputTime = new Date(timeStr);
                const now = new Date();

                const diffMs = now - inputTime; // 毫秒差
                const diffHours = diffMs / (1000 * 60 * 60);

                return diffHours > 3;
            }
        },
    }

</script>
<style scoped>

/** 搜尋欄位(年度、鄉鎮、作物、期作、關鍵字) */
.search-field
{
    padding-left: 10px;
}
/** 搜尋欄位(按鈕) */
.search-field button
{
    font-size: 13px;
}

/** 燈號狀態解釋 */
.status-light-info
{
    text-align: left;
    padding: 5px;
    font-size: 14px;
    padding-right: 25px; 
}

/** 總筆數 */
.page-row-info
{
    text-align: right;
    padding: 5px;
    font-size: 14px;
    padding-right: 25px; 
}

/** 表格 */
table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;
    border-radius: 4px;
    font-size: 12px;
    text-indent: 0;
    border-color: inherit;
}
/** 表格(表頭、表身) */
thead th, thead,tbody th, tbody, td, tfoot th, tfoot td {
    padding: 0.5rem 0.625rem 0.625rem;
    font-weight: bold;
    text-align: left;
}
/** 表格(表頭) */
thead {
    border: 1px solid #f1f1f1;
    background-color: #f1f1f1;
}
/** 表格(表身) */
tbody tr {
    border-bottom: 0;
    background-color: #ffffff;
}
tbody tr:nth-child(even) {
    background-color: #f1f1f1;
}

/** 表格-卷軸 */
.table-scroll {
    overflow-x: auto;
}

/** 表格-欄位 */
.table-field {
    text-align: center !important;
}

/** 表格-數值 */
.table-value {
    text-align: center !important;
    color:#666666;
}

/** 新增、修改彈出視窗 內容 */
#dialog_info .body
{
    max-width: 560px;
}

/** 新增、修改彈出視窗 欄位 */
#dialog_info .field
{
    text-align:right;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 8px;
    padding-right: 3px;
    width:30%;
}

/** 新增、修改彈出視窗 數值 */
#dialog_info .value
{
    width:65%;
    padding: 5px;
}

/** 必填欄位 */
.required
{
    color: #FF0000;
}

/** 沒有權限 */
.no-permissions
{
    text-align: center;

} 



.status-light {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

/* 啟用：綠燈 */
.status-light.on {
  background-color: #2ecc71;
}

/* 異常：黃燈 */
.status-light.error {
  background-color: #f3ef14;
}

/* 停用：紅燈 */
.status-light.off {
  background-color: #e74c3c;
}

.w3-modal button {

    font-size: 12px;
}

</style>